export default ({pageNum, pageSize, index}) =>
  (pageNum - 1) * pageSize + index + 1;
